// extracted by css-extract-rspack-plugin
export default {"wordmark":"qacuJ1sQ2BIkJDqA"};